export const mapResponseToResponseDataWithId = (res: any) => {
	if ("data" in res && "data" in res.data) {
		return {
			...res,
			data: {
				data: res.data.data.map((dataItem: any) => ({
					...dataItem,
					id: dataItem?.label,
				})),
			},
		};
	}

	return res.map((item: any) => ({
		...item,
		id: item?.label,
	}));
};
